import { render, staticRenderFns } from "./plan-type-popover.vue?vue&type=template&id=6a3197be&scoped=true&"
import script from "./plan-type-popover.vue?vue&type=script&lang=js&"
export * from "./plan-type-popover.vue?vue&type=script&lang=js&"
import style0 from "./plan-type-popover.vue?vue&type=style&index=0&id=6a3197be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3197be",
  null
  
)

export default component.exports